import getLocalString from "constants/Localization";
import { useDeleteOpportunityMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteOpportunity() {
  const [mutation, { loading, data, error }] = useDeleteOpportunityMutation({
    fetchPolicy: "no-cache",
    refetchQueries: ["getOpportunities"],
  });
  const [deleteOpportunity, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteOpportunity",
    },
    {
      failureMessage: getLocalString("opportunities.delete-failure"),
      successMessage: getLocalString("opportunities.delete-success"),
    }
  );
  return [deleteOpportunity, context] as const;
}
